<template>
  <Tabs type="card">
    <TabPane label="监控查询" name="query">
      <i-col>
        <modal
          v-model="addTmpModal"
          width="600"
          scrollable
          title="添加到我的监控模板">
          <div>
            <i-form :model="addTmpForm" ref="addTmpForm" :label-width="75" label-position="left" :rules="addTmpRule">
              <form-item label="模板组">
                <i-select v-model="addTmpForm.group" :transfer="true" style="width: 90%" @on-change="getMyTemplateList">
                  <i-option v-for="item in tmpGroupList" :value="item.id" :key="item.id" :label="item.name"></i-option>
                </i-select>
              </form-item>
              <form-item label="我的模板" prop="myTemplate">
                <i-select v-model="addTmpForm.myTemplate" :transfer="true" style="width: 90%" placeholder="请先选择模板组">
                  <i-option v-for="item in myTemplateList" :value="item.id" :key="item.id" :label="item.name"></i-option>
                </i-select>
                <i-button type="text" @click="changeMyTemplateModal=true"><Icon type="md-add" size="15" /></i-button>
              </form-item>
            </i-form>
          </div>
          <div slot="footer">
            <Button type="primary" @click="addTmpModalOk">提交</Button>
            <Button @click="addTmpModal = false" style="margin-left: 8px">取消</Button>
          </div>
        </modal>
        <modal
          v-model="changeMyTemplateModal"
          width="600"
          scrollable
          :title="changeMyTemplateModalTitle">
          <i-form :model="changeMyTemplateForm" ref="changeMyTemplateForm" :rules="changeMyTemplateRule" :label-width="75" label-position="left">
            <form-item label="模板组" prop="group">
              <i-select v-model="changeMyTemplateForm.group" :transfer="true">
                <i-option v-for="item in tmpGroupList" :value="item.id" :key="item.id" :label="item.name"></i-option>
              </i-select>
            </form-item>
            <form-item label="模板名称" prop="name">
              <Input v-model="changeMyTemplateForm.name" :maxlength="48" />
            </form-item>
          </i-form>
          <div slot="footer">
            <Button type="primary" @click="changeMyTemplateModalOk">提交</Button>
            <Button @click="changeMyTemplateModal = false" style="margin-left: 8px">取消</Button>
          </div>
        </modal>
        <Modal
          footer-hide
          v-model="chartScreenModal"
          width="87%">
          <div class="title" :style="{textAlign: 'center', padding: '25px'}">
            <b><span id="chartScreenId_title" :style="{fontSize: '16px'}">{{ chartScreenIdTitle }}</span></b>
          </div>
          <div :style="{height: '500px'}" id="chartScreenId"></div>
        </Modal>
        <Card shadow>
          <i-form :model="formItem" @submit.native.prevent ref="formItem" inline :label-width="75" label-position="right">
            <row>
              <form-item label="设备类型" :label-width="65" v-show="!TableIsShow">
                <i-select @on-change="getEndpointsFunc" style="width: 130px" filterable>
                  <i-option v-for="item in endpointTypeData"
                            :value="item.id"
                            :key="item.id"
                            :label="item.name"></i-option>
                </i-select>
              </form-item>
              <form-item label="设备" v-show="!TableIsShow" :label-width="40">
                <i-select v-model="formItem.endpoint" multiple filterable @on-change="v=>{ getCounters(v, true)}" :label-in-value="true" style="min-width: 100px">
                  <i-option v-for="item in endpoint_list"
                            :value="item.id"
                            :key="item.id"
                            :label="item.endpoint"></i-option>
                </i-select>
              </form-item>
              <form-item label="过滤" v-show="!TableIsShow" :label-width="40">
                <i-input v-model="formItem.counter_query" @on-change="getCounters (v=>{ getCounters(v, false)})" icon="ios-search" style="min-width: 150px"></i-input>
              </form-item>
              <form-item :style="{float: 'right',marginRight:'0'}" class="align-right">
                <i-switch v-model="TableIsShow" size="large" @on-change="controlTableShowBtnSpanFun">
                  <span slot="open">隐藏</span>
                  <span slot="close">显示</span>
                </i-switch>
              </form-item>
            </row>
          </i-form>
          <i-table
            ref="table"
            height="400"
            v-show="!TableIsShow"
            @on-row-click="rowClick"
            @on-selection-change="tableChange"
            border
            size="small"
            :columns="counter_columns"
            :data="counter_list"
            no-data-text="请至少选择一个Endpoint"
            :loading="table_loading"></i-table>
          <i-form :model="graphFilter" style="margin: 10px 0;" ref="graphFilter" label-position="right" inline>
            <form-item>
              <radio-group v-model="graphFilter.selectTime" type="button" size="small" @on-change="lastTimeChange">
                <radio label="3600">1小时</radio>
                <radio label="21600">6小时</radio>
                <radio label="43200">12小时</radio>
                <radio label="86400">1天</radio>
                <radio label="259200">3天</radio>
                <radio label="604800">7天</radio>
                <radio label="2592000">1月</radio>
              </radio-group>
            </form-item>
            <FormItem>
              <DatePicker
                v-model="customTime"
                type="datetimerange"
                style="min-width: 250px;"
                format="yyyy-MM-dd HH:mm"
                @on-ok="customTimeChange"
                @on-clear="customTimeClear"
                placeholder="自定义时间"
                class="mob-w-100"></DatePicker>
            </FormItem>
            <form-item>
              <i-select v-model="graphFilter.angle" placeholder="Endpoint视角" style="min-width: 120px;" :transfer="true" @on-change="atOneGraph">
                <i-option v-for="item in angle_list" :value="item.value" :key="item.value" :label="item.label"></i-option>
              </i-select>
            </form-item>
            <form-item>
              <i-select v-model="graphFilter.cf" placeholder="平均值" style="min-width: 100px;" :transfer="true" @on-change="atOneGraph">
                <i-option v-for="item in cf_list" :value="item.value" :key="item.value" :label="item.label"></i-option>
              </i-select>
            </form-item>
            <form-item label="求和" :label-width="45">
              <i-switch v-model="graphFilter.sum" @on-change="atOneGraph">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </form-item>
            <form-item label="只求和" :label-width="60">
              <i-switch v-model="graphFilter.sumonly" @on-change="atOneGraph">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </form-item>
            <!--<form-item label="">-->
              <!--<Input placeholder="附加标签" v-model="graphFilter.tags" v-show="!TableIsShow" style="width: 100px" @on-change="atOneGraph"/>-->
            <!--</form-item>-->
            <form-item>
              <Button @click="drawGraph" type="primary">
                <span v-if="TableIsShow">刷新</span>
                <span v-else>生成图表</span>
              </Button>
              <Button @click="addTmpModalShow" type="primary" style="margin-left: 5px;">添加到我的监控模板</Button>
            </form-item>
          </i-form>
          <div id="monitor_card">
            <Row :gutter="16">
              <div v-for="item in monitorData" v-bind:key="item.id">
                <Col :span="monitorColSpan" :style="{marginBottom: '10px'}">
                  <Col span="24">
                    <Card>
                      <p slot="title">
                        <span :id="'graph_id_' + item.id + '_title'">{{ item.title }}</span>
                        <span :style="{float : 'right'}">
                          <Button type="text" @click="chartScreen(item)" size="small">
                            <Icon type="md-expand" size="16" />
                          </Button>
                        </span>
                      </p>
                      <div :id="'graph_id_' + item.id" :style="graphDivStyle"></div>
                    </Card>
                  </Col>
                </Col>
              </div>
            </Row>
          </div>
        </Card>
      </i-col>
    </TabPane>
    <TabPane label="类型管理" name="endpoint_type_manage">
      <Drawer
        :title="batchDistCounterModalTitle"
        v-model="batchDistCounterModal"
        width="992"
        :mask-closable="true"
        @on-close="endpointTypeChangeModalCancel">
        <div>
          <Form ref="batchDistCounterForm" :model="batchDistCounterForm" :label-width="50">
            <FormItem label="设备">
              <transfer
                :data="no_select_batch_dist_endpoint"
                :target-keys="batchDistCounterForm.select_batch_dist_endpoint"
                :list-style="{
                  width: '416px',
                  height: '300px'
                }"
                @on-change="batchDistEndpointChange"
                :titles="['该类型拥有的设备', '选中设备']"
                filterable></transfer>
            </FormItem>
            <FormItem label="指标">
              <transfer
                :data="no_select_batch_dist_counter"
                :target-keys="batchDistCounterForm.select_batch_dist_counter"
                :list-style="{
                  width: '416px',
                  height: '420px'
                }"
                @on-change="batchDistCounterChange"
                :titles="['该类型拥有的指标', '选中指标']"
                filterable></transfer>
            </FormItem>
            <FormItem :style="{marginTop: '15px'}">
              <Button type="primary" @click="batchDistCounterSubmit">提交</Button>
              <Button style="margin-left: 8px" @click="batchDistCounterModalCancel">取消</Button>
            </FormItem>
          </Form>
        </div>
      </Drawer>
      <Drawer
        :title="endpointTypeModalTitle"
        v-model="endpointTypeChangeModal"
        width="992"
        :mask-closable="true"
        @on-close="endpointTypeChangeModalCancel">
        <div>
          <Form ref="endpointTypeForm" :model="endpointTypeForm" :label-width="50" :rules="endpointTypeRule">
            <FormItem label="名称" prop="name">
              <Input v-model="endpointTypeForm.name" />
            </FormItem>
            <FormItem label="指标" prop="counter">
              <transfer
                v-model="endpointTypeForm.counter"
                :data="no_select_counter"
                :target-keys="select_counter"
                :list-style="{
                  width: '420px',
                  height: '450px'
                }"
                @on-change="endpointTypeCounterChange"
                :titles="endpointTypeTransferTitles"
                filterable></transfer>
            </FormItem>
            <FormItem :style="{marginTop: '15px'}">
              <Button type="primary" @click="endpointTypeSubmit">提交</Button>
              <Button style="margin-left: 8px" @click="endpointTypeChangeModalCancel">取消</Button>
            </FormItem>
          </Form>
        </div>
      </Drawer>
      <Card shadow>
        <Row>
          <Col>
            <Button
              style="float: right;"
              @click="endpointTypeChangeModal = true; endpointTypeModalTitle='添加'"
              type="primary"
              :style="{marginBottom: '10px'}"
              icon="md-add">添加</Button>
          </Col>
        </Row>
        <Table
          border
          :columns="endpointType.columns"
          :data="endpointTypeData"
          :loading="table_loading"></Table>
      </Card>
    </TabPane>
    <TabPane label="设备管理" name="endpoint_manage" shadow>
      <Drawer
        :title="endpointClassIsTitle"
        v-model="endpointClassIsModal"
        width="550"
        :mask-closable="true"
        @on-close="endpointClassIsModalCancel">
        <Form ref="endpointClassIsForm" :model="endpointClassIsForm" :rules="endpointClassIsRule" :label-width="85">
          <FormItem label="移动到分类" prop="type">
            <i-select v-model="endpointClassIsForm.type" multiple>
              <Option v-for="item in endpointTypeData"
                      :value="item.id"
                      :key="item.id"
                      :label="item.name"></Option>
            </i-select>
          </FormItem>
          <FormItem label="是否分配选择类型的所有指标" prop="distribution" :label-width="180">
            <i-switch v-model="endpointClassIsForm.distribution">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="是否保留原有的指标" prop="stay" :label-width="135">
            <i-switch v-model="endpointClassIsForm.stay">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem :style="{marginTop: '15px'}">
            <Button type="primary" @click="endpointClassIsSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="endpointClassIsModalCancel">取消</Button>
          </FormItem>
        </Form>
      </Drawer>
      <Drawer
        :title="counterDistributionTitle"
        v-model="counterDistributionModal"
        width="1000px"
        :mask-closable="true"
        @on-close="counterDistributionModalCancel">
        <transfer
          :data="no_select_collect_counter_dist"
          :target-keys="select_collect_counter_dist"
          :list-style="{
            width: '450px',
            height: '600px'
          }"
          @on-change="counterDistributionTransferChange"
          :titles="['可选的指标', '选中指标']"
          filterable></transfer>
        <div :style="{marginTop: '15px'}">
          <Button type="primary" @click="counterDistributionSubmit">提交</Button>
          <Button style="margin-left: 8px" @click="counterDistributionModalCancel">取消</Button>
        </div>
      </Drawer>
      <Drawer
        title="从已启动监控的设备列表中收集"
        v-model="endpointCollectModal"
        width="700"
        :mask-closable="true"
        @on-close="endpointCollectModalCancel">
        <div>
          <Form ref="endpointCollectForm" :model="endpointCollectForm" :rules="endpointCollectRule" :label-width="90">
            <FormItem label="设备">
              <transfer
                v-model="endpointCollectForm.endpoint"
                :data="no_select_collect_endpoint"
                :target-keys="select_collect_endpoint"
                :list-style="listStyle"
                @on-change="endpointCollectTransferChange"
                :titles="['可选的设备', '选中设备']"
                filterable></transfer>
            </FormItem>
            <FormItem label="添加到分类" prop="type">
              <i-select v-model="endpointCollectForm.type" multiple>
                <Option v-for="item in endpointTypeData"
                        :value="item.id"
                        :key="item.id"
                        :label="item.name"></Option>
              </i-select>
            </FormItem>
            <FormItem label="是否分配选择类型的所有指标" prop="distribution" :label-width="180">
              <i-switch v-model="endpointCollectForm.distribution">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </FormItem>
            <FormItem :style="{marginTop: '15px'}">
              <Button type="primary" @click="endpointCollectSubmit" :loading="endpoint_collecting">收集</Button>
              <Button style="margin-left: 8px" @click="endpointCollectModalCancel">取消</Button>
            </FormItem>
          </Form>
        </div>
      </Drawer>
      <Card shadow>
        <Row>
          <Col span="20" :xl="22">
            <Form
              :model="searchEndpointForm"
              ref="searchEndpointForm"
              inline
              :label-width="60"
              label-position="right"
              @keyup.enter.native="getEndpointData()">
              <FormItem label="设备名">
                <Input v-model="searchEndpointForm.endpoint" style="min-width: 200px" onkeypress="if(event.keyCode === 13) return false;" />
              </FormItem>
              <FormItem label="设备类型">
                <Select v-model="searchEndpointForm.type" clearable placeholder="" style="min-width: 200px">
                  <Option v-for="item in endpointTypeData"
                          :value="item.id"
                          :key="item.id"
                          :label="item.name"></Option>
                </Select>
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" @click="getEndpointData()">搜索</Button>
                <Button style="margin-left: 8px" @click="searchEndpointReset">重置</Button>
              </FormItem>
            </Form>
          </Col>
          <Col span="4" :xl="2">
            <div style="float: right;">
              <Button
                @click="endpointCollectModal = true"
                type="primary"
                :style="{marginBottom: '10px', marginLeft: '10px'}"
                icon="ios-cloud-download-outline">收集设备</Button>
            </div>
          </Col>
        </Row>
        <Table
          border
          :columns="endpoint.columns"
          :data="endpoint.data"></Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: right;">
            <page
              :total="endpoint.count"
              :current="endpoint.page"
              :page-size="endpoint.size"
              @on-change="getEndpointData"></page>
          </div>
        </div>
      </Card>
    </TabPane>
    <TabPane label="指标管理" name="counter_manage">
      <Drawer
        :title="counterModalTitle"
        v-model="counterChangeModal"
        width="500"
        :mask-closable="true"
        @on-close="counterChangeModalCancel">
        <div>
          <Form ref="counterForm" :model="counterForm" :label-width="70" :rules="counterRule">
            <FormItem label="指标名称" prop="describe">
              <Input v-model="counterForm.describe" />
            </FormItem>
            <FormItem label="指标" prop="counter">
              <Input v-model="counterForm.counter" />
            </FormItem>
            <FormItem label="计数类型" prop="type">
              <Select v-model="counterForm.type">
                <Option value="GAUGE">原始值</Option>
                <Option value="DERIVE">计数器</Option>
              </Select>
            </FormItem>
            <FormItem label="频率(秒)" prop="step">
              <Input v-model="counterForm.step" />
            </FormItem>
            <FormItem label="说明" prop="remark">
              <Input v-model="counterForm.remark" />
            </FormItem>
            <FormItem :style="{marginTop: '15px'}">
              <Button type="primary" @click="counterChangeSubmit">提交</Button>
              <Button style="margin-left: 8px" @click="counterChangeModalCancel">取消</Button>
            </FormItem>
          </Form>
        </div>
      </Drawer>
      <Drawer
        title="收集指标"
        v-model="counterCollectModal"
        width="992"
        :mask-closable="true"
        @on-close="counterCollectModalCancel">
        <div>
          <Form ref="counterCollectForm" :model="counterCollectForm" :label-width="90">
            <FormItem label="参考设备">
              <Select @on-change="getReferenceCounters" filterable v-model="referenceCounters">
                <Option v-for="item in allEndpoint"
                        :value="item.id"
                        :key="item.id"
                        :label="item.endpoint"></Option>
              </Select>
            </FormItem>
            <FormItem label="指标关键字">
              <Input v-model="collect_query" @on-change="getReferenceCounters"/>
            </FormItem>
            <Alert type="warning" show-icon v-show="collect_show_more">指标数量大，未完全显示，请通过指标关键字过滤</Alert>
            <FormItem label="要添加的指标" prop="counter">
              <transfer
                v-model="counterCollectForm.counter"
                :data="no_select_collect_counter"
                :target-keys="select_collect_counter"
                :list-style="{
                  width: '405px',
                  height: '450px'
                }"
                @on-change="counterCollectTransferChange"
                :titles="['参考指标', '选中指标']"
                not-found-text="该Endpoint无更多指标"
                filterable></transfer>
            </FormItem>
            <FormItem :style="{marginTop: '15px'}">
              <Button type="primary" @click="counterCollectSubmit" :loading="counter_collecting">收集</Button>
              <Button style="margin-left: 8px" @click="counterCollectModalCancel">取消</Button>
            </FormItem>
          </Form>
        </div>
      </Drawer>
      <Card shadow>
        <Row>
          <Col span="24" :md="24" :lg="24">
            <Form
              :model="searchCounterForm"
              ref="searchCounterForm"
              inline
              :label-width="60"
              label-position="right"
              @keyup.enter.native="getCounterData()">
              <FormItem label="指标名称">
                <Input v-model="searchCounterForm.describe" style="min-width: 200px" />
              </FormItem>
              <FormItem label="指标">
                <Input v-model="searchCounterForm.counter" style="min-width: 200px" />
              </FormItem>
              <FormItem label="说明">
                <Input v-model="searchCounterForm.remark" style="min-width: 200px" />
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" @click="getCounterData()">搜索</Button>
                <Button style="margin-left: 8px" @click="searchCounterReset">重置</Button>
              </FormItem>
            </Form>
          </Col>
          <Col span="24" :md="24" :lg="24" class="align-right">
            <div style="float: right;">
              <Button
                @click="counterChangeModal = true; counterModalTitle='添加指标'"
                type="primary"
                :style="{marginBottom: '10px'}"
                icon="md-add">添加指标</Button>
              <Button
                @click="counterCollectModal = true"
                type="primary"
                :style="{marginBottom: '10px', marginLeft: '10px'}"
                icon="ios-cloud-download-outline">收集指标</Button>
            </div>
          </Col>
        </Row>
        <Table
          border
          :columns="allCounter.columns"
          :data="allCounter.data"></Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: right;">
            <page
              :total="allCounter.count"
              :current="allCounter.page"
              :page-size="allCounter.size"
              @on-change="getCounterData"></page>
          </div>
        </div>
      </Card>
    </TabPane>
  </Tabs>
</template>

<script>
import { getEndpointMonitorData, postTmpGraph, getAllPersonalTmpList, changeEndpointType, deleteEndpointType,
  ChangePersonalTmp, getMonitorConfig, getEndpointType, getEndpoint, getCounterListByEndpointIds, getCounterList,
  getCounter, changeCounter, deleteCounter, getAllCounter, getEndpoints, CounterCollectApi, getAllEndpoint,
  deleteEndpoint, EndpointCollectApi, changeEndpoint, detailEndpointType, BatchDistCounterApi,
  getPersonalTmpGroup } from '@/api/monitor'
import echarts from './components/echarts-use.js'
import { valueTranUnit } from '@/libs/tools'

let option = {
  title: {
    text: ''
  },
  grid: {
    x: 40,
    x2: 40,
    left: 60
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {}
    }
  },
  tooltip: {
    trigger: 'axis',
    formatter: function (params) {
      let str = '<div>' + params[0].axisValueLabel + '</div>'
      for (let i = 0; i < params.length; i++) {
        let value = params[i].data[1]
        let reValue = valueTranUnit(value, 1, '')
        str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
          '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
      }
      return str
    }
  },
  legend: {
    x: 'center',
    y: 'bottom',
    type: 'scroll',
    width: '87%',
    icon: 'rect',
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 15
  },
  xAxis: {
    type: 'time',
    splitLine: {
      show: true
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true
    },
    axisLabel: {
      formatter: function (value) {
        return valueTranUnit(value, 0)
      }
    }
  },
  series: []
}
export default {
  name: 'query',
  data () {
    return {
      monitorTheme: 'dark',
      TableIsShow: false,
      monitorCardIsShow: false,
      controlTableShowBtnSpan: 12,
      formItem: {
        endpoint: [],
        tag: '',
        counter: [],
        counter_query: ''
      },
      customTime: '',
      endpoint_label_list: [],
      endpointValueList: [],
      endpoint_list: [],
      counter_selected_list: [],
      counter_list: [],
      angle_list: [
        {
          value: 'endpoint',
          label: '设备视角'
        },
        {
          value: 'counter',
          label: '指标视角'
        },
        {
          value: 'merge',
          label: '组合视角'
        }
      ],
      cf_list: [
        {
          value: 'AVERAGE',
          label: '平均值'
        },
        {
          value: 'MAX',
          label: '最大值'
        },
        {
          value: 'MIN',
          label: '最小值'
        }
      ],
      graphFilter: {
        angle: 'endpoint',
        cf: 'AVERAGE',
        sum: false,
        sumonly: false,
        selectTime: '3600',
        start: '',
        end: '',
        tags: ''
      },
      labelInValue: true,
      table_loading: false,
      table_total: 1,
      table_limit: 0,
      table_current_page: 1,
      counter_columns: [
        {
          type: 'selection',
          minWidth: 50,
          align: 'center'
        },
        {
          title: '指标名称',
          key: 'describe',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '指标',
          key: 'counter',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '计数类型',
          key: 'type',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const res = row.type === 'GAUGE' ? '原始值' : row.type === 'DERIVE' ? '计数器' : row.type
            return h('span', res)
          }
        },
        {
          title: '频率(秒)',
          key: 'step',
          minWidth: 110,
          align: 'center'
        },
        {
          title: '说明',
          key: 'remark',
          minWidth: 80,
          align: 'center'
        }
      ],
      addTmpModal: false,
      addTmpForm: {
        myTemplate: ''
      },
      addTmpRule: {
        myTemplate: [
          {required: true, type: 'number', message: '请选择一个模板', trigger: 'change'}
        ]
      },
      myTemplateList: [],
      changeMyTemplateModal: false,
      changeMyTemplateModalTitle: '新建一个模板',
      changeMyTemplateForm: {
        id: 0,
        name: '',
        group: ''
      },
      changeMyTemplateRule: {
        group: [
          {required: true, type: 'number', message: '请选择模板组', trigger: 'change'}
        ],
        name: [
          {required: true, message: '模板名称是必填的', trigger: 'blur'}
        ]
      },

      monitorIndex: 0,
      monitorData: [],
      chartScreenModal: false,
      chartScreenIdTitle: '',
      monitorColSpan: 12,
      graphDivStyle: {
        height: '300px'
      },
      tmpGroupList: [],

      // 设备类型管理
      endpointTypeChangeModal: false,
      no_select_counter: [],
      select_counter: [],
      endpointTypeModalTitle: '添加',
      endpointTypeData: [],
      endpointType: {
        columns: [
          {
            title: 'ID',
            key: 'id',
            align: 'center',
            minWidth: 100
          },
          {
            title: '类型名称',
            key: 'name',
            align: 'center',
            minWidth: 90
          },
          {
            title: '指标数量',
            key: 'counter',
            align: 'center',
            minWidth: 90,
            render: (h, params) => {
              return h('div', params.row.counter.length)
            }
          },
          {
            title: '设备数量',
            key: 'endpoint_count',
            align: 'center',
            minWidth: 90
          },
          {
            title: '分配 / 回收 指标',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'text',
                    size: 'small',
                    ghost: true
                  },
                  style: {
                    color: '#19be6b',
                    marginRight: '10px',
                    border: '1px dashed #19be6b'
                  },
                  on: {
                    click: () => {
                      this.batchDistCounterForm.action = 'dist'
                      this.batchDistCounterModalTitle = '分配指标：' + params.row.name
                      this.batchDistCounterModalOpen(params.row)
                      this.batchDistCounterModal = true
                    }
                  }
                }, '分配'),
                h('Button', {
                  props: {
                    type: 'text',
                    size: 'small',
                    ghost: true
                  },
                  style: {
                    color: '#ff9900',
                    border: '1px dashed #ff9900'
                  },
                  on: {
                    click: () => {
                      this.batchDistCounterForm.action = 'remove'
                      this.batchDistCounterModalTitle = '回收指标：' + params.row.name
                      this.batchDistCounterModalOpen(params.row)
                      this.batchDistCounterModal = true
                    }
                  }
                }, '回收')
              ])
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.endpointTypeModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.endpointTypeDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ]
      },
      endpointTypeForm: {
        id: '',
        name: '',
        counter: []
      },
      endpointTypeRule: {
        name: [
          {required: true, message: '类型名称是必填的', trigger: 'blur'}
        ]
      },
      endpointTypeTransferTitles: ['参考指标', '选中指标'],
      listStyle: {
        width: '250px',
        height: '300px'
      },
      batchDistCounterModal: false,
      batchDistCounterModalTitle: '分配 / 回收 指标',
      no_select_batch_dist_endpoint: [],
      no_select_batch_dist_counter: [],
      batchDistCounterForm: {
        action: 'dist',
        select_batch_dist_endpoint: [],
        select_batch_dist_counter: []
      },

      // 设备管理
      endpoint_collecting: false,
      endpoint: {
        data: [],
        columns: [
          {
            title: 'ID',
            key: 'id',
            align: 'center',
            minWidth: 100
          },
          {
            title: '设备名',
            key: 'endpoint',
            align: 'center',
            minWidth: 130
          },
          {
            title: '是否默认告警',
            key: 'is_default_alarm',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              if (params.row.is_default_alarm) {
                return h('Tag', {
                  props: {
                    color: 'success'
                  }
                }, '是')
              } else {
                return h('Tag', '否')
              }
            }
          },
          // {
          //   title: '告警组',
          //   render: (h, params) => {
          //     let re = []
          //     if (params.row.group_name_list) {
          //       if (params.row.group_name_list['status'] === 1) {
          //         for (let i in params.row.group_name_list['data']) {
          //           re.push(h('Tag', params.row.group_name_list['data'][i]))
          //         }
          //       }
          //     }
          //     return h('div', re)
          //   }
          // },
          {
            title: '类型',
            key: 'type',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let re = []
              if (params.row.type_name_list) {
                for (let i in params.row.type_name_list) {
                  re.push(h('Tag', params.row.type_name_list[i]))
                }
              }
              return h('div', re)
            }
          },
          {
            title: '指标数量',
            key: 'counter',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('div', params.row.counter.length)
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 220,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.counterDistributionModalOpen(params.row)
                    }
                  }
                }, '指标分配'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.endpointClassIsModalOpen(params.row)
                    }
                  }
                }, '移动分类'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.endpointDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      endpointCollectModal: false,
      select_collect_endpoint: [],
      no_select_collect_endpoint: [],
      endpointCollectForm: {
        endpoint: [],
        type: [],
        distribution: true
      },
      endpointCollectRule: {
        type: [
          {required: true, validator: this.validSelectRule, message: '请选择分类', trigger: 'change'}
        ],
        distribution: [
          {required: true, type: 'boolean', message: '', trigger: 'change'}
        ]
      },
      counterDistributionModal: false,
      counterDistributionTitle: '指标分配',
      no_select_collect_counter_dist: [],
      select_collect_counter_dist: [],
      counterDistId: '',
      endpointClassIsTitle: '',
      endpointClassIsModal: false,
      currentEditEndpointCounters: [],
      endpointClassIsForm: {
        id: '',
        type: [],
        distribution: true,
        stay: true
      },
      endpointClassIsRule: {
        type: [
          {required: true, validator: this.validSelectRule, message: '请选择分类', trigger: 'change'}
        ],
        distribution: [
          {required: true, type: 'boolean', message: '', trigger: 'change'}
        ],
        stay: [
          {required: true, type: 'boolean', message: '', trigger: 'change'}
        ]
      },
      searchEndpointForm: {
        endpoint: '',
        type: ''
      },

      // 指标管理
      counter_collecting: false,
      counterChangeModal: false,
      counterCollectModal: false,
      collect_query: '',
      collect_show_more: false,
      allCounter: {
        data: [],
        columns: [
          {
            title: 'ID',
            key: 'id',
            align: 'center',
            minWidth: 100
          },
          {
            title: '指标名称',
            key: 'describe',
            align: 'center',
            minWidth: 150
          },
          {
            title: '指标',
            key: 'counter',
            align: 'center',
            minWidth: 200
          },
          {
            title: '计数类型',
            key: 'type',
            align: 'center',
            minWidth: 100
          },
          {
            title: '频率(秒)',
            key: 'step',
            align: 'center',
            minWidth: 90
          },
          {
            title: '说明',
            key: 'remark',
            align: 'center',
            minWidth: 80
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.counterModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.counterDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      counterModalTitle: '添加指标',
      counterForm: {
        id: '',
        describe: '',
        counter: '',
        type: 'GAUGE',
        step: '60',
        remark: ''
      },
      counterRule: {
        counter: [
          {required: true, message: '指标是必填的', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '计数类型是必选的', trigger: 'change'}
        ],
        step: [
          {required: true, message: '频率是必填的', trigger: 'change'}
        ]
      },
      referenceCounters: '',
      counterCollectForm: {
        counter: []
      },

      allEndpoint: [],
      no_select_collect_counter: [],
      select_collect_counter: [],
      existCounter: [],
      searchCounterForm: {
        describe: '',
        counter: '',
        remark: ''
      }
    }
  },
  mounted: function () {
    this.getEndpointTypeData()
    this.getTheme()
    this.getAllCounterData()
    this.getCounterData()
    this.getAllEndpoints()
    this.getEndpointData()
    this.getTmpGroupList()
  },
  methods: {
    getEndpointsFunc (typeId) {
      this.endpoint_list = []
      this.formItem.endpoint = []
      if (!typeId) {
        return false
      }
      let params = {
        type: typeId
      }
      getAllEndpoint(params).then(res => {
        this.endpoint_list = res.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getCounters (mdata, reset = false) {
      this.counter_list = []
      this.counter_selected_list = []
      if (reset) {
        this.endpoint_label_list = []
        this.formItem.counter_query = ''
        for (let i in mdata) {
          this.endpoint_label_list.push(mdata[i].label)
        }
        if (mdata.length <= 0) {
          return false
        }
      }
      let reqData = {
        query: this.formItem.counter_query,
        endpoint_list: this.formItem.endpoint
      }
      this.table_loading = true
      getCounterListByEndpointIds(reqData).then(res => {
        this.table_loading = false
        this.counter_list = res.data.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取监控指标列表失败！',
            desc: '请求状态码:' + res.request.status + ', ' + res.request.responseText
          })
        }
      })
    },
    tableChange (data) {
      let that = this
      that.counter_selected_list = []
      for (let i in data) {
        that.counter_selected_list.push(data[i].counter)
      }
    },
    rowClick (data, index) {
      let that = this
      that.$refs.table.objData[index]._isChecked = !that.$refs.table.objData[index]._isChecked
      if (that.$refs.table.objData[index]._isChecked) {
        that.counter_selected_list.push(data.counter)
      } else {
        that.counter_selected_list = []
        for (let i in that.$refs.table.objData) {
          if (that.$refs.table.objData[i]._isChecked) {
            that.counter_selected_list.push(that.$refs.table.objData[i].counter)
          }
        }
      }
    },
    drawGraph () {
      let that = this
      that.monitorData = []
      if (that.endpoint_label_list.length <= 0 || that.counter_selected_list.length <= 0) {
        that.monitorCardIsShow = false
        this.$Notice.error({title: '请至少选择1个Endpoint和Counter'})
        return false
      }
      that.monitorCardIsShow = true
      if (that.graphFilter.angle === 'endpoint') {
        that.TableIsShow = true
        if (that.counter_selected_list.length === 1) {
          this.monitorColSpan = 24
          this.graphDivStyle.height = '500px'
        } else {
          this.monitorColSpan = 12
          this.graphDivStyle.height = '300px'
        }
        for (let v in that.counter_selected_list) {
          let reqData = {
            'last': that.graphFilter.selectTime,
            'angle': that.graphFilter.angle,
            'cf': that.graphFilter.cf,
            'sum': that.graphFilter.sum,
            'sumonly': that.graphFilter.sumonly,
            'start': that.graphFilter.start,
            'end': that.graphFilter.end,
            'tags': that.graphFilter.tags
          }
          let titleT = that.counter_selected_list[v]
          reqData.endpoints = that.endpoint_label_list
          reqData.counters = [titleT]
          this.monitorIndex++
          reqData.id = this.monitorIndex
          reqData.title = titleT
          this.monitorData.push(reqData)
          that.getGraphData(reqData, 'graph_id_' + this.monitorIndex)
        }
      } else if (that.graphFilter.angle === 'counter') {
        if (that.endpoint_label_list.length === 1) {
          this.monitorColSpan = 24
          this.graphDivStyle.height = '500px'
        } else {
          this.monitorColSpan = 12
          this.graphDivStyle.height = '300px'
        }
        for (let v in that.endpoint_label_list) {
          let reqData = {
            'last': that.graphFilter.selectTime,
            'angle': that.graphFilter.angle,
            'cf': that.graphFilter.cf,
            'sum': that.graphFilter.sum,
            'sumonly': that.graphFilter.sumonly,
            'start': that.graphFilter.start,
            'end': that.graphFilter.end,
            'tags': that.graphFilter.tags
          }
          let titleT = that.endpoint_label_list[v]
          reqData.endpoints = [titleT]
          reqData.counters = that.counter_selected_list
          this.monitorIndex++
          reqData.id = this.monitorIndex
          reqData.title = titleT
          this.monitorData.push(reqData)
          that.getGraphData(reqData, 'graph_id_' + this.monitorIndex)
        }
      } else {
        this.monitorColSpan = 24
        this.graphDivStyle.height = '500px'
        let reqData = {
          'last': that.graphFilter.selectTime,
          'angle': that.graphFilter.angle,
          'cf': that.graphFilter.cf,
          'sum': that.graphFilter.sum,
          'sumonly': that.graphFilter.sumonly,
          'start': that.graphFilter.start,
          'end': that.graphFilter.end,
          'tags': that.graphFilter.tags
        }
        reqData.endpoints = that.endpoint_label_list
        reqData.counters = that.counter_selected_list
        this.monitorIndex++
        reqData.id = this.monitorIndex
        reqData.title = '组合数据'
        this.monitorData.push(reqData)
        that.getGraphData(reqData, 'graph_id_' + this.monitorIndex)
      }
    },
    getGraphData (reqData, graphId) {
      let that = this
      getEndpointMonitorData(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          if (result.data.title) {
            reqData.title = result.data.title
          }
          let data = result.data.series
          let dseries = []
          let haveArea = false
          let monitorTheme = this.monitorTheme
          if (monitorTheme.endsWith('-line')) {
            monitorTheme = monitorTheme.split('-line')[0]
          } else {
            haveArea = true
          }
          for (let v in data) {
            let dSeriesConfig = {
              name: data[v].name,
              data: data[v].data,
              type: 'line',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1
                  }
                }
              }
            }
            if (haveArea) {
              dSeriesConfig.areaStyle = {
                opacity: 0.2
              }
            }
            dseries.push(dSeriesConfig)
          }
          option.series = dseries
          let graphLine = echarts.init(document.getElementById(graphId), monitorTheme)
          window.addEventListener('resize', function () {
            graphLine.resize()
          })
          graphLine.clear()
          graphLine.setOption(option, true)
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！',
            desc: result.msg
          })
        }
      }).catch(res => {
        that.table_current_page = 1
        that.table_total = 1
        if (res.request) {
          this.$Notice.error({
            title: '获取监控数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！服务器无响应'
          })
        }
      })
    },
    controlTableShowBtnSpanFun () {
      if (this.TableIsShow) {
        this.controlTableShowBtnSpan = 24
      } else {
        this.controlTableShowBtnSpan = 12
      }
    },
    addTmpModalShow () {
      let that = this
      if (that.endpoint_label_list.length <= 0 || that.counter_selected_list.length <= 0) {
        that.monitorCardIsShow = false
        this.$Notice.error({title: '请至少选择1个Endpoint和Counter'})
        return
      }
      this.addTmpModal = true
    },
    addTmpModalOk () {
      this.$refs['addTmpForm'].validate((valid) => {
        if (valid) {
          let that = this
          if (!that.graphFilter.selectTime) {
            this.$Notice.error({title: '加入模板不能选择自定义时间！'})
            return false
          }
          let reqData = {
            'tmp': that.addTmpForm.myTemplate,
            'endpoints': that.endpoint_label_list,
            'counters': that.counter_selected_list,
            'last': that.graphFilter.selectTime,
            'angle': that.graphFilter.angle,
            'cf': that.graphFilter.cf,
            'sum': that.graphFilter.sum,
            'sumonly': that.graphFilter.sumonly,
            'tags': that.graphFilter.tags
          }
          postTmpGraph(reqData).then(res => {
            this.addTmpModal = false
            that.addTmpForm.group = ''
            that.addTmpForm.myTemplate = ''
            that.myTemplateList = []
            that.$Notice.success({title: '操作成功！'})
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        } else {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getMyTemplateList (groupId) {
      if (!groupId) {
        this.myTemplateList = []
        return false
      }
      let that = this
      getAllPersonalTmpList({ group: groupId }).then(res => {
        that.myTemplateList = res.data
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeMyTemplateModalOk () {
      this.$refs['changeMyTemplateForm'].validate((valid) => {
        if (valid) {
          let that = this
          let reqData = that.changeMyTemplateForm
          ChangePersonalTmp(reqData, that.changeMyTemplateForm.id).then(res => {
            that.changeMyTemplateModal = false
            that.addTmpForm.group = ''
            that.addTmpForm.myTemplate = ''
            that.myTemplateList = []
            that.changeMyTemplateForm.id = 0
            that.changeMyTemplateForm.name = ''
          }).catch(res => {
            that.$Notice.error({
              title: '操作失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        }
      })
    },
    getTheme () {
      getMonitorConfig().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.monitorTheme = result.data.theme
        }
      })
    },
    atOneGraph () {
      if (this.TableIsShow) {
        this.drawGraph()
      }
    },
    chartScreen (data) {
      this.chartScreenModal = true
      this.graphFilter = data
      this.graphFilter.selectTime = data.last + ''
      this.chartScreenIdTitle = data.title
      this.getGraphData(data, 'chartScreenId')
    },
    lastTimeChange () {
      this.customTime = ''
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.atOneGraph()
    },
    customTimeChange () {
      let timeRange = [this.customTime[0].getTime() / 1000, this.customTime[1].getTime() / 1000]
      if (timeRange[0] && timeRange[1]) {
        this.graphFilter.selectTime = ''
        this.graphFilter.start = timeRange[0]
        this.graphFilter.end = timeRange[1]
      } else {
        this.graphFilter.selectTime = '3600'
        this.graphFilter.start = ''
        this.graphFilter.end = ''
      }
      this.atOneGraph()
    },
    customTimeClear () {
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.graphFilter.selectTime = '3600'
      this.atOneGraph()
    },

    // 设备类型管理
    getEndpointTypeData () {
      getEndpointType().then(res => {
        this.endpointTypeData = res.data
      })
    },
    endpointTypeModifyOpen (row) {
      this.endpointTypeModalTitle = '修改Endpoint类型：' + row.name
      this.endpointTypeForm.id = row.id
      this.endpointTypeForm.name = row.name
      this.endpointTypeForm.counter = row.counter
      this.select_counter = row.counter
      this.endpointTypeChangeModal = true
    },
    endpointTypeChangeModalCancel () {
      this.$refs['endpointTypeForm'].resetFields()
      this.endpointTypeForm.id = ''
      this.select_counter = []
      this.endpointTypeChangeModal = false
    },
    endpointTypeDelete (row) {
      deleteEndpointType(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getEndpointTypeData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    endpointTypeCounterChange (targetData) {
      this.select_counter = targetData
      this.endpointTypeForm.counter = targetData
    },
    getAllCounterData () {
      this.no_select_counter = []
      this.existCounter = []
      getAllCounter().then(res => {
        let result = res.data
        for (let i in result) {
          this.existCounter.push(result[i].counter)
          let label = result[i].counter
          if (result[i].describe) {
            label = result[i].describe + ' - ' + label
          }
          this.no_select_counter.push({
            key: result[i].id,
            label: label
          })
        }
      })
    },
    endpointTypeSubmit () {
      this.$refs['endpointTypeForm'].validate((valid) => {
        if (valid) {
          if (this.endpointTypeForm.counter.length <= 0) {
            this.$Notice.error({
              title: '至少选择一项监控指标！'
            })
            return false
          }
          changeEndpointType(this.endpointTypeForm, this.endpointTypeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getEndpointData()
            this.getEndpointTypeData()
            this.endpointTypeChangeModalCancel()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },

    batchDistEndpointChange (targetData) {
      this.batchDistCounterForm.select_batch_dist_endpoint = targetData
    },
    batchDistCounterChange (targetData) {
      this.batchDistCounterForm.select_batch_dist_counter = targetData
    },
    batchDistCounterSubmit () {
      if (this.batchDistCounterForm.select_batch_dist_endpoint.length === 0) {
        this.$Notice.error({
          title: '请至少选择一个设备！'
        })
        return false
      }
      if (this.batchDistCounterForm.select_batch_dist_counter.length === 0) {
        this.$Notice.error({
          title: '请至少选择一项指标！'
        })
        return false
      }
      let reqData = {
        action: this.batchDistCounterForm.action,
        endpoint_list: this.batchDistCounterForm.select_batch_dist_endpoint,
        counter_list: this.batchDistCounterForm.select_batch_dist_counter
      }
      BatchDistCounterApi(reqData).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.batchDistCounterForm.select_batch_dist_endpoint = []
        this.batchDistCounterForm.select_batch_dist_counter = []
        this.getEndpointData()
        this.batchDistCounterModalCancel()
      })
    },
    batchDistCounterModalOpen (row) {
      let reqParams = {
        type: row.id
      }
      getAllEndpoint(reqParams).then(res => {
        this.no_select_batch_dist_endpoint = []
        this.no_select_batch_dist_counter = []
        for (let i in res.data) {
          this.no_select_batch_dist_endpoint.push({
            key: res.data[i].id,
            label: res.data[i].endpoint
          })
        }

        let reqParams2 = {
          id__in: row.counter.join(',')
        }
        getAllCounter(reqParams2).then(res2 => {
          for (let i in res2.data) {
            let label = res2.data[i].counter
            if (res2.data[i].describe) {
              label = res2.data[i].describe + ' - ' + label
            }
            this.no_select_batch_dist_counter.push({
              key: res2.data[i].id,
              label: label
            })
          }
        })
      })
    },
    batchDistCounterModalCancel () {
      this.$refs['batchDistCounterForm'].resetFields()
      this.batchDistCounterModal = false
    },

    // 设备管理
    getEndpointData (value = 1) {
      this.endpoint.page = value
      let params = {
        size: this.endpoint.size,
        page: this.endpoint.page,
        endpoint: this.searchEndpointForm.endpoint,
        type: this.searchEndpointForm.type
      }
      getEndpoint(params).then(res => {
        this.endpoint.data = res.data.results
        this.endpoint.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取设备管理列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取设备管理列表失败！服务器无响应'
          })
        }
      })
    },
    endpointDelete (row) {
      deleteEndpoint(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getEndpointData()
        this.getAllEndpoints()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    endpointCollectModalCancel () {
      this.$refs['endpointCollectForm'].resetFields()
      this.select_collect_endpoint = []
      this.counterDistId = ''
      this.endpointCollectModal = false
    },
    endpointCollectTransferChange (targetData) {
      this.select_collect_endpoint = targetData
    },
    endpointCollectSubmit () {
      this.$refs['endpointCollectForm'].validate((valid) => {
        if (valid) {
          if (this.select_collect_endpoint.length === 0) {
            this.$Notice.error({
              title: '请至少选择一个Endpoint'
            })
            return false
          }
          let reqData = {
            type: this.endpointCollectForm.type,
            distribution: this.endpointCollectForm.distribution,
            endpoint_list: this.select_collect_endpoint
          }
          this.endpoint_collecting = true
          EndpointCollectApi(reqData).then(res => {
            this.endpoint_collecting = false
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getEndpointData()
              this.getAllEndpoints()
              this.endpointCollectModalCancel()
            } else {
              this.$Notice.error({
                title: '操作失败！',
                desc: result.msg
              })
            }
          }).catch(res => {
            this.endpoint_collecting = false
            this.$Notice.error({
              title: '操作失败！',
              desc: result.msg
            })
          })
        }
      })
    },

    counterDistributionModalOpen (row) {
      if (!row.type.length) {
        this.$Notice.error({
          title: '请先将此设备加入分类！'
        })
        return false
      }
      let params = {
        id__in: row.type_counter.join(',')
      }
      this.no_select_collect_counter_dist = []
      getAllCounter(params).then(res => {
        for (let i in res.data) {
          let label = res.data[i].counter
          if (res.data[i].describe) {
            label = res.data[i].describe + ' - ' + label
          }
          this.no_select_collect_counter_dist.push({
            key: res.data[i].id,
            label: label
          })
        }
        this.select_collect_counter_dist = row.counter
        this.counterDistId = row.id
        this.counterDistributionTitle = '指标分配：' + row.endpoint
        this.counterDistributionModal = true
      })
    },
    counterDistributionModalCancel () {
      this.select_collect_counter_dist = []
      this.counterDistId = ''
      this.counterDistributionModal = false
    },
    counterDistributionTransferChange (targetData) {
      this.select_collect_counter_dist = targetData
    },
    counterDistributionSubmit () {
      let reqData = {
        counter: this.select_collect_counter_dist
      }
      changeEndpoint(reqData, this.counterDistId).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.getEndpointData(this.endpoint.page)
        this.counterDistributionModalCancel()
      })
    },

    endpointClassIsModalOpen (row) {
      this.endpointClassIsForm.id = row.id
      this.endpointClassIsForm.type = row.type
      this.endpointClassIsTitle = '移动分类：' + row.endpoint
      this.currentEditEndpointCounters = row.counter
      this.endpointClassIsModal = true
    },
    endpointClassIsModalCancel () {
      this.$refs['endpointClassIsForm'].resetFields()
      this.endpointClassIsModal = false
    },
    endpointClassIsSubmit () {
      let reqData = {
        type: this.endpointClassIsForm.type,
        counter: []
      }
      if (this.endpointClassIsForm.stay) {
        reqData.counter = this.currentEditEndpointCounters
      }
      if (this.endpointClassIsForm.distribution) {
        let forLen = 0
        for (let i in reqData.type) {
          detailEndpointType(reqData.type[i]).then(res => {
            reqData.counter = reqData.counter.concat(res.data.counter)
            forLen += 1
            if (forLen === reqData.type.length) {
              this.changeEndpointAction(reqData, this.endpointClassIsForm.id)
            }
          })
        }
      } else {
        this.changeEndpointAction(reqData, this.endpointClassIsForm.id)
      }
    },
    changeEndpointAction (reqData, id) {
      changeEndpoint(reqData, id).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.getEndpointData(this.endpoint.page)
        this.getEndpointTypeData()
        this.endpointClassIsModalCancel()
      })
    },
    searchEndpointReset () {
      this.searchEndpointForm = {
        endpoint: '',
        type: ''
      }
    },

    // 指标管理
    getCounterData (value = 1) {
      this.allCounter.page = value
      let params = {
        size: this.allCounter.size,
        page: this.allCounter.page,
        describe: this.searchCounterForm.describe,
        counter: this.searchCounterForm.counter,
        remark: this.searchCounterForm.remark
      }
      getCounter(params).then(res => {
        this.allCounter.data = res.data.results
        this.allCounter.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取指标管理列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取指标管理列表失败！服务器无响应'
          })
        }
      })
    },
    counterModifyOpen (row) {
      this.counterModalTitle = '修改指标：' + row.describe + ' - ' + row.counter
      this.counterForm.id = row.id
      this.counterForm.describe = row.describe
      this.counterForm.counter = row.counter
      this.counterForm.type = row.type
      this.counterForm.step = row.step + ''
      this.counterForm.remark = row.remark
      this.counterForm.tenant_id = row.tenant_id
      this.counterChangeModal = true
    },
    counterDelete (row) {
      deleteCounter(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getCounterData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    counterChangeModalCancel () {
      this.$refs['counterForm'].resetFields()
      this.counterForm.id = ''
      this.counterChangeModal = false
    },
    counterChangeSubmit () {
      this.$refs['counterForm'].validate((valid) => {
        if (valid) {
          changeCounter(this.counterForm, this.counterForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getCounterData(this.allCounter.page)
            this.getAllCounterData()
            this.counterChangeModalCancel()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getAllEndpoints () {
      this.no_select_collect_endpoint = []
      getEndpoints().then(res => {
        let result = res.data
        this.allEndpoint = result.data
        let existEndpoint = []
        getAllEndpoint().then(resB => {
          for (let v in resB.data) {
            existEndpoint.push(resB.data[v].endpoint)
          }
          for (let i in this.allEndpoint) {
            if ($.inArray(result.data[i]['endpoint'], existEndpoint) !== -1) {
              continue
            }
            this.no_select_collect_endpoint.push({
              key: result.data[i]['endpoint'],
              label: result.data[i]['endpoint']
            })
          }
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    counterCollectModalCancel () {
      this.referenceCounters = ''
      this.collect_query = ''
      this.select_collect_counter = []
      this.no_select_collect_counter = []
      this.counterCollectModal = false
    },
    getReferenceCounters () {
      let params = {
        eid: [this.referenceCounters],
        query: this.collect_query
      }
      this.select_collect_counter = []
      this.no_select_collect_counter = []
      getCounterList(params).then(res => {
        let result = res.data
        if (result.data.length > 499) {
          this.collect_show_more = true
        } else {
          this.collect_show_more = false
        }
        if (result.code === 200) {
          for (let i in result.data) {
            if ($.inArray(result.data[i]['counter'], this.existCounter) !== -1) {
              continue
            }
            this.no_select_collect_counter.push({
              key: result.data[i]['counter'],
              label: result.data[i]['counter']
            })
          }
        }
      })
    },
    counterCollectTransferChange (targetData) {
      this.select_collect_counter = targetData
    },
    counterCollectSubmit () {
      if (this.select_collect_counter.length === 0) {
        this.$Notice.error({
          title: '请至少选择一项指标'
        })
        return false
      }
      let reqData = {
        eid: this.referenceCounters,
        counter_list: this.select_collect_counter
      }
      this.counter_collecting = true
      CounterCollectApi(reqData).then(res => {
        this.counter_collecting = false
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.getCounterData()
          this.getAllCounterData()
          this.counterCollectModalCancel()
        } else {
          this.$Notice.error({
            title: '操作失败！',
            desc: result.msg
          })
        }
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！',
          desc: result.msg
        })
        this.counter_collecting = false
      })
    },
    searchCounterReset () {
      this.searchCounterForm = {
        describe: '',
        counter: '',
        remark: ''
      }
    },
    validSelectRule (rule, value, callback) {
      if (!value.length) {
        callback(new Error())
      } else {
        callback()
      }
    },
    getTmpGroupList () {
      getPersonalTmpGroup().then(res => {
        this.tmpGroupList = res.data
      }).catch(errO => {
        this.$Notice.error({
          title: '获取模板组失败！'
        })
        this.tmpGroupList = []
      })
    }
  }
}
</script>

<style>
  #monitor_card .ivu-card-body {
    padding: 0;
  }
  #monitor_card .ivu-card-head {
    background-color: #F2F2F2;
    height: 30px;
    padding:0;
  }
  #monitor_card .ivu-card-head p {
    padding-left: 10px;
    height: 30px;
    line-height: 30px;
    text-align:center;
  }
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
